import React from "react";
import "../../css/sharedStyles.css";
import "./comicDetail.css";
import axios from "axios";
import {grabMainComic} from "../includes/grabMainComic.js";
import {buildSelectedComicQuery} from "../includes/buildSelectedComicQuery.js";
import {getMainComic} from "../includes/axios/getMainComic.js";
import ComicCreators from "./ComicCreators.js";
import {spinningGlobeEffect} from "../includes/spinningGlobeEffect.js";

var ComicDetail = class ComicDetail extends React.Component{
    

    constructor(props) {
        super(props);

      }  

    componentDidMount () {
        window.scrollTo(0, 0);
      }


    render() {
      const inlineStyle = {
        marginBottom:"10px"
      }

    //determine if we render the comics cover or the spinning globe effect
    var comicImage = this.props.mainComicInfo.comicCover;
    var comicName = this.props.mainComicInfo.comicTitle;
    var comicCover = spinningGlobeEffect(comicImage,comicName);

      return (
        <div>
            <div className="comicDetail content_box_square" id="mobileDescriptionArea" style={{'textAlign':'left'}}>
                <div className="MOBILEheadshot">
                    <img src={this.props.mainComicInfo.comicCover} className="MOBILEheadshotImage"/>
                </div>
                
                    <h1 className='MOBILEcharacterName'>{this.props.mainComicInfo.comicTitle}</h1>
                    <div className="MOBILEdescription">{this.props.mainComicInfo.comicDescription}</div>
                    <ComicCreators mainComicInfo = {this.props.mainComicInfo} textStyle ={"creatorsContainerMobile"}/>
            </div>       
        
        
            <div className="comicDetail" id="desktopCharacter"> 
                <div className="content_box_square imgBoxWidth" id="mainComicCover">
                    {comicCover}
                </div>

                <div className="content_box_square textBoxWidth" id="mobileDescriptionArea">
                    <h1 className="characterName">{this.props.mainComicInfo.comicTitle}</h1>
                    <p className="characterDescription">{this.props.mainComicInfo.comicDescription}</p>
                </div>

            </div>
        </div>
 
      );
    }
  }

  export default ComicDetail;


// WEBPACK FOOTER //
// ./src/components/comicDetail/ComicDetail.js